import { Injectable } from "@angular/core";
import { HttpService } from "../../services/http/http.service";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  constructor(private http: HttpService) {}

  checkUserStatus(username: string): Observable<any> {
    if (!username) return of(null);
    return this.http
      .postMethod("Login/checkuserstatusLds", { user: username })
      .pipe(catchError(err => of({ error: err })));
  }

  loginLDAP(userName: string, password: string): Observable<any> {
    const payload = { strUserName: userName, strPassword: password };
    return this.http
      .postMethod("ldap/validate", JSON.stringify(payload))
      .pipe(catchError(err => of({ error: err })));
  }

   loginNLDAP(data: { userId: string; userPass: string; source: string }): Observable<any> {
    return this.http
      .postMethod("login/loginMain", data)
      .pipe(catchError(err => of({ error: err })));
  }


  checkUserActive(userId: string): Observable<any> {
    return this.http
      .postMethod("login/chkUserActive", { userId })
      .pipe(catchError(err => of({ error: err })));
  }

  validateUser(userObj: any): Observable<any> {
    return this.http
      .postMethod("login/validateUser", userObj)
      .pipe(catchError(err => of({ error: err })));
  }

  truncateAll(): Observable<any> {
    return this.http
      .getMethod("login/truncateAll")
      .pipe(catchError(err => of({ error: err })));
  }
}
